/**
 * Team Grid Frontend JavaScript
 * Handles hover interactions for team member cards
 */

document.addEventListener("DOMContentLoaded", function () {
  const teamMembers = document.querySelectorAll(".team-member-item");

  teamMembers.forEach(function (member) {
    const imageWrapper = member.querySelector(".member-image-wrapper");

    if (!imageWrapper) return;

    const mainImage = imageWrapper.querySelector(".member-image");
    const hoverImage = imageWrapper.querySelector(".member-image-hover");
    const overlay = imageWrapper.querySelector(".member-overlay");
    const socials = imageWrapper.querySelector(".member-socials");

    // Mouse enter
    imageWrapper.addEventListener("mouseenter", function () {
      if (hoverImage) {
        mainImage.style.opacity = "0";
        hoverImage.style.opacity = "1";
      }

      if (overlay) {
        overlay.style.transform = "translateY(0)";
        overlay.style.opacity = "1";
      }

      if (socials) {
        socials.style.transform = "translateY(0)";
        socials.style.opacity = "1";
      }
    });

    // Mouse leave
    imageWrapper.addEventListener("mouseleave", function () {
      if (hoverImage) {
        mainImage.style.opacity = "1";
        hoverImage.style.opacity = "0";
      }

      if (overlay) {
        overlay.style.transform = "translateY(100%)";
        overlay.style.opacity = "0";
      }

      if (socials) {
        socials.style.transform = "translateY(100%)";
        socials.style.opacity = "0";
      }
    });

    // Touch support for mobile
    imageWrapper.addEventListener("touchstart", function (e) {
      const isActive = imageWrapper.classList.contains("is-active");

      // Remove active class from all other members
      teamMembers.forEach(function (otherMember) {
        if (otherMember !== member) {
          const otherWrapper = otherMember.querySelector(
            ".member-image-wrapper"
          );
          if (otherWrapper) {
            otherWrapper.classList.remove("is-active");
            resetMember(otherWrapper);
          }
        }
      });

      // Toggle current member
      if (isActive) {
        imageWrapper.classList.remove("is-active");
        resetMember(imageWrapper);
      } else {
        imageWrapper.classList.add("is-active");
        activateMember(imageWrapper);
      }
    });
  });

  // Helper function to activate member on touch
  function activateMember(wrapper) {
    const mainImage = wrapper.querySelector(".member-image");
    const hoverImage = wrapper.querySelector(".member-image-hover");
    const overlay = wrapper.querySelector(".member-overlay");
    const socials = wrapper.querySelector(".member-socials");

    if (hoverImage) {
      mainImage.style.opacity = "0";
      hoverImage.style.opacity = "1";
    }

    if (overlay) {
      overlay.style.transform = "translateY(0)";
      overlay.style.opacity = "1";
    }

    if (socials) {
      socials.style.transform = "translateY(0)";
      socials.style.opacity = "1";
    }
  }

  // Helper function to reset member
  function resetMember(wrapper) {
    const mainImage = wrapper.querySelector(".member-image");
    const hoverImage = wrapper.querySelector(".member-image-hover");
    const overlay = wrapper.querySelector(".member-overlay");
    const socials = wrapper.querySelector(".member-socials");

    if (hoverImage) {
      mainImage.style.opacity = "1";
      hoverImage.style.opacity = "0";
    }

    if (overlay) {
      overlay.style.transform = "translateY(100%)";
      overlay.style.opacity = "0";
    }

    if (socials) {
      socials.style.transform = "translateY(100%)";
      socials.style.opacity = "0";
    }
  }

  // Close active member when clicking outside on mobile
  document.addEventListener("touchstart", function (e) {
    const isTeamMember = e.target.closest(".team-member-item");

    if (!isTeamMember) {
      teamMembers.forEach(function (member) {
        const wrapper = member.querySelector(".member-image-wrapper");
        if (wrapper && wrapper.classList.contains("is-active")) {
          wrapper.classList.remove("is-active");
          resetMember(wrapper);
        }
      });
    }
  });
});
